'use client';

import { TextPassage } from '@petsmart-ui/sparky';
import { useWatch } from 'react-hook-form';

import { useCurbsideQuery } from '@libs/common-next';
import type { Product, TailoredApiData } from '@libs/common-types';

import { CurbsideInfoDetail } from '../CurbsideInfoDetail';
import { getShippingRestrictionText } from '../product-details';
import { useMiniPdpDrawer } from './model/use-mini-pdp-drawer';

type MiniPdpDisclaimersProps = Readonly<{
    product: Product;
    tailored: TailoredApiData | null;
}>;

export function MiniPdpDisclaimers({ product, tailored }: MiniPdpDisclaimersProps) {
    const selectedMethod = useWatch({ name: 'fulfilmentMethod' });
    const selectedSku = useWatch({ name: 'selectedSku' });
    const isOpen = useMiniPdpDrawer(state => state.isOpen);
    const close = useMiniPdpDrawer(state => state.close);
    const { curbsideData } = useCurbsideQuery();

    const shippingRestriction =
        selectedMethod === 'sth' ? getShippingRestrictionText(product.deliveryMethods.STH.poBoxRestricted) : null;
    const storeId = selectedSku ? tailored?.variants[selectedSku]?.BOPIS?.storeId : undefined;
    const storeOffersCurbside = Boolean(storeId && tailored?.bopisStoreData?.[storeId]?.offersCurbsidePickup);
    const showCurbside = selectedMethod === 'bopis' && storeOffersCurbside && Boolean(curbsideData);

    if (!shippingRestriction && !showCurbside) return null;

    return (
        <div className="mini-pdp-drawer__disclaimers" data-testid="mini-pdp-disclaimers">
            {shippingRestriction && <TextPassage data-testid="po-box">{shippingRestriction}</TextPassage>}
            {showCurbside && <CurbsideInfoDetail showBackButton forceClosed={!isOpen} onCloseAll={close} />}
        </div>
    );
}
